import { Routes } from '@angular/router';
import { routesAdminAgendamento } from './routes_admin_agendamentos';
import { routesAdminDadosEmpresa } from './routes_admin_dados_empresa';
import { routesAdminFinanceiro } from './routes_admin_financeiro';
import { routesAdminMaterial } from './routes_admin_material';
import { routesAdminParceiro } from './routes_admin_parceiro';
import { routesAdminPedido } from './routes_admin_pedido';
import { routesAdminTratamentos } from './routes_admin_tratamento';
import { routesAdminParametrizacao } from './routes_parametrizacao';

export const routesAdmin: Routes = [
  ...routesAdminParceiro,
  ...routesAdminMaterial,
  ...routesAdminParametrizacao,
  ...routesAdminFinanceiro,
  ...routesAdminDadosEmpresa,
  ...routesAdminPedido,
  ...routesAdminTratamentos,
  ...routesAdminAgendamento
];
